export default __webpack_public_path__ + "static/media/t360.d1a56993.png";